<template>
  <v-sheet :width="'100%'" :elevation="4">
    <v-container>
      <v-expansion-panels>
        <v-expansion-panel v-for="carrier in carriers" :key="carrier.name">
          <v-expansion-panel-header>{{
            carrier.name
          }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <ul v-for="info in carrier.info" :key="info">
              <li>{{ info }}</li>
            </ul>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  name: "Vue",
  data() {
    return {
      carriers: [
        {
          name: "AIG",
          info: [
            "Founded in 1919",
            "Home Office: New York, New York",
            "Sold Worldwide in more than 80 countries",
            "500 Billion in Assets",
          ],
        },
        {
          name: "Americo",
          info: [
            "Founded in 1946",
            "Home Office: Kansas City, Missouri",
            "AM Best: A rating",
            "One of the largest independent life insurance companies in the US",
          ],
        },
        {
          name: "ANICO(American National Insurance Company)",
          info: [
            "Founded in 1905",
            "Home Office: Galveston, Texas",
            "AM Best: A rating",
            "1918-19 - Meets all claims during the Spanish Flu Epidemic when many companies struggled",
            "1930-35 - Expands during the worst of the Great Depression Frequently on the “100 Most Trustworthy Financial Companies list",
          ],
        },
        {
          name: "Foresters",
          info: [
            "Founded in 1874",
            "Home Office: New York, New York",
            "AM Best: A rating",
            "Over 18 billion dollars in assets",
            "Fraternal company with many customer benefits",
            "Very community oriented with donations, grants and scholarships",
          ],
        },
        {
          name: "Liberty Bankers",
          info: [
            "Founded in 1958",
            "Home Office: Dallas, Texas",
            "Over 2 billion dollars in assets",
            "One of the top final expense carriers in the US",
          ],
        },
        {
          name: "Mutual of Omaha",
          info: [
            "Founded in 1909",
            "Home Office: Omaha, Nebraska",
            "Fortune 500 Company",
            "Over 43 billion dollars in assets",
            "Over 6,000 employees",
          ],
        },
        {
          name: "Prosperity",
          info: [
            "Real Names: S USA Life Insurance company and SBLI Life Insurance",
            "Founded in 1939",
            "Home Office: New York, New York",
            "Started as Savings Bank Life Insurance (SBLI)",
          ],
        },
        {
          name: "Royal Neighbors",
          info: [
            "Founded in 1895",
            "Home Office: Rock Island, Illinois",
            "One of the top women-led organizations",
            "One of the first life insurance companies to insure women and children",
            "Fraternal company with many customer benefits",
            "Very community oriented with volunteering, grants and scholarships",
          ],
        },
        {
          name: "Sagicor",
          info: [
            "Founded in 1840",
            "US Home Office: Scottsdale, Arizona",
            "Has bought other companies and changed its name many times",
            "Policies sold world-wide as Sagicor Financial",
            "Have invested their money in technology, not advertising",
            "The best policies for their customers",
          ],
        },
        {
          name: "Great Western",
          info: [
            "Founded in 1983",
            "Home Office: Ogden, UT",
            "AM Best Rating: A",
            "Over 2.4 Billion dollars in assets",
            "Started in the pre-arranged funerals business and has lots of experience helping customers with their final expense needs",
          ],
        },
        {
          name: "North American",
          info: [
            "Founded in 1886",
            "Home Office: Des Moines, IA",
            "AM Best Rating: A+",
            "Very community minded, donate millions to charities every year.",
          ],
        },
        {
          name: "Protective Life",
          info: [
            "Founded in 1907",
            "Home Office: Birmingham, AL",
            "AM Best Rating: A",
            "Over 127 Billion dollars in assets",
            "Very community minded",
          ],
        },
        {
          name: "Ethos",
          info: [
            "Founded in 2016",
            "Home Office: San Francisco",
            "They are a 3rd party administrator for well-known life insurance companies:",
            "Ameritas Life",
            "AAA Life",
            "Principal Financial",
            "Am Best Rating: All of their carriers are A+ Rated",
          ],
        },
      ],
    };
  },
  mounted() {
    this.carriers.sort(function (a, b) {
      var nameA = a.name.toUpperCase();
      var nameB = b.name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0;
    });
  },
};
</script>